import { EventTicketType } from './../../model/tsp/ticket-type';
import { RootState } from '..';

export const selectTicketTypes = (state: RootState): EventTicketType[] => state.ticket.ticketTypes;
export const selectSelectedTicketTypes = (state: RootState): EventTicketType[] => state.ticket.selectedTicketTypes;
export const selectEventsLastUpdate = (state: RootState): EventTicketType[] => state.ticket.eventsLastUpdate;
